require('./bootstrap');

window.Vue = require('vue');

const CC = require("cookieconsent")

window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    "palette": {
      "popup": {
        "background": "#3c3f3c",
        "text": "white"
      },
      "button": {
        "background": "#37bbe4",
        "text": "white"
      },
    },
    "content": {
        "href": "/cookie-policy"
    }

  });
});

import { createApp } from 'vue';

globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;

import HomepageHero from './components/HomepageHero.vue';
import EventCard from './components/EventCard.vue';
import EventFilters from './components/EventFilters.vue';
import Events from './components/Events.vue';
import ExternalLinkModal from './components/ExternalLinkModal.vue';
import FlashMessage from './components/FlashMessage.vue';
import FlashMessages from './components/FlashMessages.vue';
import OrganisationPersonModal from './components/OrganisationPersonModal.vue';

const app = createApp({
    el: '#app',
    delimiters: ['${', '}'],
    data: function() {
        return {
            mobilenavopen: false,
            externalLinkModalOpen: false,
            organisationPersonModalOpen: false,
            organisationPerson: {},
            newSiteHref: ''
        };
    },
    created() {
        document.addEventListener('click', this.documentClick);
    },
    destroyed() {
        document.removeEventListener('click', this.documentClick)
    },
    methods: {
        openNav: function () {
            document.body.classList.add('modal-open');
            this.mobilenavopen = true;
        },
        closeNav: function () {
            document.body.classList.remove('modal-open');
            this.mobilenavopen = false;
        },
        documentClick(e) {
            var node = e.target;
            if (this.externalLinkModalOpen) {

                let el = this.$refs.externalLinkModal.$refs.modalContainer;

                let isCloseButton = !!node.closest('.close');

                if (isCloseButton || ((el !== node) && !el.contains(node))) {
                    this.hideExternalSiteMessage();
                    return false;
                }

                return true;
            }

            if (this.organisationPersonModalOpen &! node.classList.contains('read-more')) {

                let el = this.$refs.organisationModal.$refs.modalContainer;

                let isCloseButton = !!node.closest('.close');

                if (isCloseButton || ((el !== node) && !el.contains(node))) {
                    this.hideOrganisationModal();
                    return false;
                }

                return true;
            }

            while (node != undefined && node.localName != 'a') {
                node = node.parentNode;
            }
            if (node != undefined) {
                if (this.isExternal(node.href)
                &! this.isPDF(node.href)
                &! this.isOurAsset(node.href)
                &! this.isMailTo(node.href)
                ) {
                    e.preventDefault();
                    this.showExternalSiteMessage(node.href);
                    return false;
                }
            }
        },
        isExternal: function (url) {
            return ((url.indexOf(':') > -1 || url.indexOf('//') > -1) && this.checkDomain(location.href) !== this.checkDomain(url));
        },
        isPDF: function(url) {
            return url.endsWith('.pdf');
        },
        isOurAsset: function(url) {
            return url.startsWith(window.asset_url);
        },
        isMailTo: function(url) {
            return url.startsWith('mailto:');
        },
        checkDomain: function (url) {
            if (url.indexOf('//') === 0) { url = location.protocol + url; }
            return url.toLowerCase().replace(/([a-z])?:\/\//, '$1').split('/')[0];
        },
        showExternalSiteMessage(href) {
            document.body.classList.remove('modal-open');
            this.externalLinkModalOpen = true;
            this.newSiteHref = href;
        },
        hideExternalSiteMessage() {
            document.body.classList.remove('modal-open');
            this.externalLinkModalOpen = false;
        },
        showOrganisationModal(data){
            document.body.classList.add('modal-open');
            this.organisationPerson = data;
            this.organisationPersonModalOpen = true;
        },
        hideOrganisationModal() {
            document.body.classList.remove('modal-open');
            this.organisationPerson = {};
            this.organisationPersonModalOpen = false;
        }


    }
});

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => app.component(key.split('/').pop().split('.')[0], files(key).default))

app.mount( '#app' );
